import { OrganizationKeyName } from "../../../model/Organization";

export const UPSERT_PRODUCT_CATEGORY = "SHOP:UPSERT_PRODUCT_CATEGORY";

export const upsertProductCategoryAction = (
  organization: OrganizationKeyName,
  data: any,
  id?: string
) => ({
  type: UPSERT_PRODUCT_CATEGORY as typeof UPSERT_PRODUCT_CATEGORY,
  organization,
  data,
  id,
});

export type UpsertProductCategoryAction = ReturnType<
  typeof upsertProductCategoryAction
>;
